import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle, faInfoCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

interface ToastProps {
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
}

export function Toast({ message, type }: ToastProps) {
  const getIcon = () => {
    switch (type) {
      case 'success': return <FontAwesomeIcon icon={faCheckCircle} />;
      case 'error': return <FontAwesomeIcon icon={faTimesCircle} />;
      case 'info': return <FontAwesomeIcon icon={faInfoCircle} />;
      case 'warning': return <FontAwesomeIcon icon={faExclamationTriangle} />;
      default: return null;
    }
  };

  const getStyles = () => {
    switch (type) {
      case 'success': return { background: '#10b981', color: '#fff' };
      case 'error': return { background: '#ef4444', color: '#fff' };
      case 'info': return { background: '#3b82f6', color: '#fff' };
      case 'warning': return { background: '#f59e0b', color: '#fff' };
      default: return {};
    }
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: '24px',
      right: '24px',
      zIndex: 1000,
      padding: '12px 20px',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      animation: 'slideIn 0.3s ease-out',
      ...getStyles()
    }}>
      {getIcon()}
      <span style={{ fontSize: '14px', fontWeight: 500 }}>{message}</span>
      <style>{`
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
